import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../..'

const getCurrentMarker = (state: RootState) => state.map.currentMarker;
const getMapCentre = (state: RootState) => state.map.mapCentre;
const getMapSettings = (state: RootState) => state.map.initialMapData.settings;
const getMapZoom = (state: RootState) => state.map.mapZoom;

export const currentMarkerSelector = createSelector(
    getCurrentMarker,
    currentMarker => currentMarker
)

export const mapCentreSelector = createSelector(
    getMapCentre,
    mapCentre => mapCentre
)

export const mapSettingsSelector = createSelector(
    getMapSettings,
    settings => settings
)

export const mapZoomSelector = createSelector(
    getMapZoom,
    mapZoom => mapZoom
)